import { ProductType, ProteinGroup } from 'api/foodaid/questions';

export default {
  [ProteinGroup.Poultry]: 'Gevogelte',
  [ProteinGroup.BeefAndVeal]: 'Rund & Kalf',
  [ProteinGroup.Horse]: 'Paard',
  [ProteinGroup.Wild]: 'Wild',
  [ProteinGroup.Fish]: 'Vis',
  [ProteinGroup.Lamb]: 'Lam',
  [ProteinGroup.Goat]: 'Geit',
  [ProteinGroup.Kangaroo]: 'Kangoeroe',
  [ProteinGroup.VegetarianOrVegan]: 'Vegetarisch/Veganistisch',
  [ProductType.Dryfood]: 'Droogvoer',
  [ProductType.Wetfood]: ' Natvoer',
  [ProductType.Barf]: ' BARF',
  [`usp-${ProteinGroup.Poultry}`]:
    '<fragment> <li> Licht verteerbaar & vetarm</li> <li> Populairste vleessoort </li> </fragment>',
  [`usp-${ProteinGroup.BeefAndVeal}`]:
    '<fragment> <li>Hoge acceptatie </li> <li>Rijk aan ijzer & fosfor</li> </fragment> ',
  [`usp-${ProteinGroup.Horse}`]:
    '<fragment> <li>Ideaal voor allergiepatiënten </li> <li> Bijzonder mager </li> </fragment> ',
  [`usp-${ProteinGroup.Wild}`]:
    '<fragment> <li>Vlees uit het wild </li> <li> Zeer goed verteerbaar</li> </fragment> ',
  [`usp-${ProteinGroup.Fish}`]:
    '<fragment> <li>Rijk aan natuurlijke omega 3-vetzuren </li> </fragment> ',
  [`usp-${ProteinGroup.Lamb}`]:
    '<fragment> <li>Ideaal voor allergiepatiënten </li> <li>Bijzonder smaakvol </li> </fragment> ',
  [`usp-${ProteinGroup.Goat}`]:
    '<fragment> <li>Ideaal voor allergiepatiënten </li> <li> Bijzonder goed verteerbaar</li> </fragment> ',
  [`usp-${ProteinGroup.Kangaroo}`]:
    '<fragment> <li>Ideaal voor allergiepatiënten </li> <li> Bijzonder goed verteerbaar </li> </fragment> ',
  [`usp-${ProteinGroup.VegetarianOrVegan}`]:
    '<fragment> <li>Voor milieubewuste viervoeters </li> <li> Perfect bij intoleranties voor dierlijke eiwitten </li> </fragment> ',
};
